import { EModelApiPaths } from '../app/enums/EModelApiPaths';

export const environment = {
    production: false,
    SWEVENNE_BE_HOST_PORT: 'https://rr.dev.be.savaapi.com',
    USER_PATH: 'admingbs',
    INS: 'mongodb',
    DB: 'swevenne',
    authTokenInfo: 'swevenne_authorization_email', // it will be secret path.
    SWEVENNE_BE_WS_HOST_PORT: 'wss://rr.dev.ws.savaapi.com',
    IS_ENCRYPTED: false,
    ENV: 'DEV', // DEV | QA | PROD,
    BUCKET_NAME: 'sava-s3',
    FILE_PATH: 'swevenne-dev',
    FILE_URL: 'https://sava-s3.in-maa-1.linodeobjects.com/',
    RAZOR_PAY_KEY: 'rzp_test_5alfLLpuNKfY9y',

    // common
    COMMON_DB: 'common',

    crypto: {
        passJWT: 'dbec4c8c-8dd3-488e-b845-0e708400d4b5', // dev serve // it is secretFETransfer from secret
    },

    get SWEVENNE_BE_HOST_PORT_SITES() {
        return this.SWEVENNE_BE_HOST_PORT + `${EModelApiPaths.API}`;
    },
};
